import React from "react";
import {
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    CircularProgress,
    Checkbox,
} from "@mui/material";

import DialogModel from "components/DialogModel/DialogModel";
import { ConvertToTitleCase, FormatDate } from "commonFunctions/commonFunctions";
import TablePage from "components/TablePage/TablePage";

const EhrOrdersTable = (props) => {
    return <div className="enc-data-section" >
        <TableContainer component={Paper} className="enc-table">
            <Table stickyHeader aria-label="customized table">
                <TableHead className="thBorder">
                    <TableRow>
                        <TableCell className="tableHeadStyle">Select</TableCell>
                        <TableCell className="tableHeadStyle">No.</TableCell>
                        <TableCell className="tableHeadStyle">Order Number</TableCell>
                        <TableCell className="tableHeadStyle">Date</TableCell>
                        <TableCell className="tableHeadStyle">Status</TableCell>
                        <TableCell className="tableHeadStyle">Intent</TableCell>
                        <TableCell className="tableHeadStyle">Category</TableCell>
                        <TableCell className="tableHeadStyle">Order Name</TableCell>
                        <TableCell className="tableHeadStyle">Encounter Type</TableCell>
                        <TableCell className="tableHeadStyle">Ordering Provider</TableCell>
                        <TableCell className="tableHeadStyle">Associated Diagnosis</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {!props.tabLoader && props.ordersData &&
                        props.ordersData.map((data, i) => (
                            <TableRow
                                key={i}
                                className={props.doc_level === "Order" && props.selectedOrders.includes(data.identifier) ? "ehr-table-row-color" : "table-row"}
                            >
                                <TableCell className="tableCellStyle" align="left">
                                    <Checkbox
                                        size="small"
                                        checked={props.documentLevel === "Order" && props.selectedOrders.includes(data.identifier)}
                                        onChange={(event) => props.handleOrdersSelection(event, data)}
                                        disabled={props.documentLevel !== "Order"}
                                    />
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.s_no}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.identifier}
                                </TableCell>
                                <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                    {data.authoredOn && FormatDate({ date: data.authoredOn, format: "MM/DD/YYYY" })}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {ConvertToTitleCase(data.status, "-")}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {ConvertToTitleCase(data.intent, "-")}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.category}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.code}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.encounter}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.requester}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left" sx={{ maxWidth: "200px"}}>
                                    {data.reasonCode.toString()}
                                </TableCell>

                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            {props.loader ? <CircularProgress size={30} className="popup-spinner" /> : (props.ordersData && props.ordersData.length === 0 && <DialogModel /> || null)}
        </TableContainer>
        <TablePage
            count={props.pagination.totalRecords}
            recordsPerPage={props.pagination.recordsPerPage}
            pageNum={props.pagination.currentPage}
            handleChangePage={props.handleChangePage}
        />
    </div>
}

export default EhrOrdersTable;
